import {ReactNode, FC} from 'react'
import {MainContainer} from './Layout.styles'

export const DashboardLayout: FC<{children: ReactNode[] | ReactNode}> = ({
  children,
}) => {
  return <MainContainer isSnackbarAvailable={false}>{children}</MainContainer>
}
